<nav class="navbar-expand-md navbar-light bg-white shadow-sm fixed-bottom d-flex d-xl-none mobile-bottom-nav" v-if="$route.name !== 'cart_checkout'">
  <ul class="navbar-nav d-flex flex-row justify-content-between w-100 text-xs fw-30px0 p-2 d-xl-none mobile-bottom-nav-list">

    <li v-if="client_features.show_portals && !is_group_page && token_exists" class="nav-item d-flex flex-column align-items-center justify-content-center text-center" :class="{ 'is-mobile-nav-active': is_mobile_nav_active('portals') }" :style="get_mobile_nav_item_style('portals')"> <!-- Increased mx spacing -->
      <a class="portal-avatar text-dark d-flex align-items-center justify-content-center" data-bs-toggle="offcanvas" href="#portals" role="button" aria-controls="portals">
        <i class="bx bx-command"></i>
      </a>
      <span v-if="client_features.portals_label" class="text-xxs text-center">{{client_features.portals_label}}</span>
    </li>
    <li v-if="!isHomePage && !is_group_page && !isHomeFilterPage && isPortalPage  && token_exists" class="nav-item d-flex flex-column align-items-center justify-content-center text-center mx-3" :class="{ 'is-mobile-nav-active': is_mobile_nav_active('boards') }" :style="get_mobile_nav_item_style('boards')"> <!-- Increased mx spacing -->
      <a class="portal-avatar text-dark d-flex align-items-center justify-content-center" data-bs-toggle="offcanvas" href="#boards_offcanvas" role="button" aria-controls="boards_offcanvas">

        <i class="bi bi-kanban-fill"></i>
      </a>
      <span class="text-xxs text-center">Boards</span>
    </li>

    <li class="nav-item d-flex flex-column align-items-center justify-content-center text-center" :class="{ 'is-mobile-nav-active': is_mobile_nav_active('feeds') }" :style="get_mobile_nav_item_style('feeds')">
      <a class="portal-avatar text-dark d-flex align-items-center justify-content-center" href="/home">
        <i class="fas fa-scroll fa-fw text-black fs-1 mt-1"></i>
      </a>
      <span class="text-xxs text-center">Feeds</span>
    </li>

    <li v-if="!isHomePage && !is_group_page && !isHomeFilterPage && isPortalPage   && token_exists" class=" d-none nav-item d-flex flex-column align-items-center justify-content-center text-center" :class="{ 'is-mobile-nav-active': is_mobile_nav_active('segments') }" :style="get_mobile_nav_item_style('segments')">
      <a class="portal-avatar text-center text-dark" data-bs-toggle="offcanvas" href="#topics" role="button" aria-controls="topics_label">
        <img src="@/assets/images/light-bulb.png" class="w-30px" alt="">
      </a>
      <span class="text-xxs text-center">Segments</span>
    </li>
    <li v-if="client_features.show_marketplace && !isPortalPage && !is_business_page && !is_group_page" class="nav-item d-flex flex-column align-items-center justify-content-center text-center" :class="{ 'is-mobile-nav-active': is_mobile_nav_active('marketplace') }" :style="get_mobile_nav_item_style('marketplace')">
        <a class="portal-avatar text-dark d-flex align-items-center justify-content-center" href="/marketplace">
          <i class="fas fa-store fa-fw text-black fs-1 mt-1"></i>
        </a>
        <span class="text-xxs text-center">Marketplace</span>
      </li>
      <li v-if="client_features.show_incident && !isPortalPage && !is_business_page && !is_group_page" class="nav-item d-flex flex-column align-items-center justify-content-center text-center" :class="{ 'is-mobile-nav-active': is_mobile_nav_active('incident') }" :style="get_mobile_nav_item_style('incident')">
        <a class="portal-avatar text-dark d-flex align-items-center justify-content-center" href="/incident_reporting">
          <i class="fas fa-screwdriver-wrench fa-fw text-black fs-1 mt-1"></i>
        </a>
        <span class="text-xxs text-center">Incident</span>
      </li>

   <li v-if="client_features.show_events && !is_group_page && !isHomeFilterPage && !isPortalPage" class="nav-item d-flex flex-column align-items-center justify-content-center text-center" :class="{ 'is-mobile-nav-active': is_mobile_nav_active('events') }" :style="get_mobile_nav_item_style('events')">
  <a class="portal-avatar text-center text-dark d-flex align-items-center justify-content-center" href="/view_events">
    <i class="fas fa-calendar-alt fa-fw text-black fs-1 mt-1"></i> <!-- events/calendar icon -->
  </a>
  <span class="text-xxs text-center">Events</span>
</li>

<li class="nav-item d-flex flex-column align-items-center justify-content-center text-center" v-if="!isHomePage && token_exists && isPortalPage || is_group_page" :class="{ 'is-mobile-nav-active': is_mobile_nav_active('groups') }" :style="get_mobile_nav_item_style('groups')">
  <a class="portal-avatar text-dark d-flex align-items-center justify-content-center" data-bs-toggle="offcanvas" href="#groups" role="button" aria-controls="groups">
    <i class="fas fa-g fa-fw text-black fs-1 mt-1"></i> <!-- letter G icon -->
  </a>
  <span class="text-xxs text-center">Groups</span>
</li>

<li v-if="token_exists" class="nav-item d-flex flex-column align-items-center justify-content-center text-center sticky-nav-notification" :class="{ 'is-mobile-nav-active': is_mobile_nav_active('alerts') }" :style="get_mobile_nav_item_style('alerts')">
  <NotificationDropdown />
  <span class="text-xxs text-center">Alerts</span>
</li>


 <li v-if="show_group_member_mobile_nav" class="nav-item d-flex flex-column align-items-center justify-content-center text-center" :class="{ 'is-mobile-nav-active': is_mobile_nav_active('group_member') }" :style="get_mobile_nav_item_style('group_member')">
      <a class="portal-avatar text-dark d-flex align-items-center justify-content-center" data-bs-toggle="offcanvas" href="#group_members" role="button" aria-controls="group_members_label">
        <i class='bx bx-group fs-3'></i>
      </a>
      <span class="text-xxs text-center">Group member</span>
    </li>

<li v-if="!is_group_page && !isPortalPage && token_exists" class="nav-item d-flex flex-column align-items-center justify-content-center text-center" :class="{ 'is-mobile-nav-active': is_mobile_nav_active('menu') }" :style="get_mobile_nav_item_style('menu')">
  <a class="portal-avatar text-dark d-flex align-items-center justify-content-center" data-bs-toggle="offcanvas" href="#menu" role="button" aria-controls="menu_canvas">
    <i class="fas fa-bars fa-fw fs-1 mt-1"></i> <!-- menu icon -->
  </a>
  <span class="text-xxs text-center">Menu</span>
</li>

  </ul>
</nav>
<!-- </div> -->

<!-- <div class="v-i">v-if="token_exists && user_details.user_role == 'admin' " -->

  <div v-if="token_exists && (user_details.user_role == 'admin' || user_details.user_role == 'organization admin')"  class="offcanvas offcanvas-start" tabindex="-1" id="portals" aria-labelledby="portalsLabel">
    <div class="offcanvas-body">
      <div class="d-flex justify-content-between mt-5">
        <div class="d-flex align-items-center mt-3">
            <h5 v-if="cbo_domain"class="offcanvas-title" id="portals_label">Memberships</h5>
            <h5 v-else class="offcanvas-title mx-2" id="portals_label"></h5>
        </div>
            <button type="button" class="btn-close text-reset mt-4" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div v-if="portals.length" class="portal-sidebar-card portal-sidebar-card-list mt-3">
        <div class="portal-sidebar-header d-flex align-items-center justify-content-between rounded">
          <h6 class="mb-0">
            <span v-if="school_domain">All Grades</span>
            <span v-else>All Portals</span>
          </h6>
          <CreatePortal @create-portal="createPortal"/>
        </div>
        <div class="portal-sidebar-body">
          <div class="portal-sidebar-list d-flex flex-column">
            <button
              v-for="portal in portals"
              :key="'your-'+portal.id"
              type="button"
              class="portal-sidebar-item"
              @click="handlePortalClick(portal)"
              data-bs-dismiss="offcanvas"
            >
              <span class="portal-sidebar-avatar">
                {{ getInitials(portal.name) }}
              </span>
              <span class="portal-sidebar-name">
                {{ portal.name }}
              </span>
              <i v-if="!portal.is_public" class="bx bxs-lock portal-sidebar-lock"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-else class="portal-sidebar-card border mt-3">
        <div class="portal-sidebar-body text-center py-4 px-3">
          <CreatePortal @create-portal="createPortal"/>

          <h6 class="fw-bold mb-1">
            <span v-if="school_domain">No grades yet</span>
            <span v-else>No portals yet</span>
          </h6>
          <p class="text-muted text-xxs mb-3">
            <span v-if="school_domain">Create your first grade to get started.</span>
            <span v-else>Create your first portal to get started.</span>
          </p>
        </div>
      </div>
    </div>
  </div>
    <div v-else class="offcanvas offcanvas-start" tabindex="-1" id="portals" aria-labelledby="portalsLabel">
    <div class="offcanvas-body">
      <div class="d-flex justify-content-between mt-5">
        <div class="d-flex align-items-center mt-3">
            <h5 v-if="cbo_domain"class="offcanvas-title" id="portals_label">Memberships</h5>
            <h5 v-else class="offcanvas-title mx-2" id="portals_label"></h5>
        </div>
            <button type="button" class="btn-close text-reset mt-4" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div v-if="portals.length">
    <div v-if="your_portals.length" class="portal-sidebar-card portal-sidebar-card-compact mt-3">
      <div class="portal-sidebar-header d-flex align-items-center justify-content-between rounded">
        <h6 class="mb-0">
          <span v-if="school_domain">Your Grades</span>
          <span v-else>Your Portals</span>
        </h6>
        <CreatePortal v-if="user_details.user_role === 'admin' || user_details.user_role === 'organization admin'|| portal_admin" @create-portal="createPortal"/>
      </div>
      <div class="portal-sidebar-body">
        <div class="portal-sidebar-list d-flex flex-column">
          <button
            v-for="portal in displayed_your_portals"
            :key="'your-'+portal.id"
            type="button"
            class="portal-sidebar-item"
            @click="handlePortalClick(portal)"
            data-bs-dismiss="offcanvas"
          >
            <span class="portal-sidebar-avatar">
              {{ getInitials(portal.name) }}
            </span>
            <span class="portal-sidebar-name">
              {{ portal.name }}
            </span>
            <i v-if="!portal.is_public" class="bx bxs-lock portal-sidebar-lock"></i>
          </button>
        </div>
        <button
          v-if="has_more_your_portals"
          type="button"
          class="portal-sidebar-see-all btn btn-link btn-sm w-100 text-decoration-none"
          @click="toggle_your_portals"
        >
          {{ show_all_your_portals ? 'See Less' : 'See All' }}
        </button>
      </div>
    </div>

    <div v-if="other_portals.length" class="portal-sidebar-card portal-sidebar-card-list portal-sidebar-card-mobile-scroll mt-3">
      <div class="portal-sidebar-header d-flex align-items-center justify-content-between rounded">
        <h6 class="mb-0">
          <span v-if="school_domain">Other Grades</span>
          <span v-else>Other Portals</span>
        </h6>
        <CreatePortal
          v-if="!your_portals.length"
          @create-portal="createPortal"
        />
      </div>
      <div class="portal-sidebar-body">
        <div class="portal-sidebar-list d-flex flex-column">
          <button
            v-for="portal in other_portals"
            :key="'other-'+portal.id"
            type="button"
            class="portal-sidebar-item"
            @click="handlePortalClick(portal)"
            data-bs-dismiss="offcanvas"
          >
            <span class="portal-sidebar-avatar">
              {{ getInitials(portal.name) }}
            </span>
            <span class="portal-sidebar-name">
              {{ portal.name }}
            </span>
            <span v-if="portal.has_access === 'pending'" class="badge rounded-pill bg-warning text-dark text-xxs">Pending</span>
            <i v-else-if="!portal.is_public" class="bx bxs-lock portal-sidebar-lock"></i>
          </button>
        </div>
      </div>
    </div>
</div>
      <div v-else class="portal-sidebar-card border mt-3">
        <div class="portal-sidebar-body text-center py-4 px-3">
          <CreatePortal @create-portal="createPortal"/>

          <h6 class="fw-bold mb-1">
            <span v-if="school_domain">No grades yet</span>
            <span v-else>No portals yet</span>
          </h6>
          <p class="text-muted text-xxs mb-3">
            <span v-if="school_domain">Create your first grade to get started.</span>
            <span v-else>Create your first portal to get started.</span>
          </p>
        </div>
      </div>
<!-- 
      {{portals}}
     
      <table v-if="portals.length" class="table mb-0">
        <tbody>
          <tr v-for="portal in portals" :key="portal.id" class="hover-row border-0 " v-show="portal.name?.toLowerCase() !== 'default portal'">
            <td class="border-0">
              <span class="text-decoration-none" @click="handlePortalClick(portal)" data-bs-dismiss="offcanvas">
                <p class="portal-icon mb-0 d-flex align-items-center">
                  <a class="portal-avatar bg-yellow p-1 shadow-sm text-change"><i class='bx bx-command'></i></a>
                  <span class="text-xs fw-30px0 mx-2">{{ portal.name }} <i v-if="!portal.is_public"
                      class='bx bxs-lock text-change text-xxs'></i></span>
                </p>
              </span>
            </td>
          </tr>
        </tbody>
      </table> -->
    </div>
  </div>

  <div class="offcanvas offcanvas-end mt-4" tabindex="-1" id="menu" aria-labelledby="menu">
    <div class="offcanvas-header mt-5">
                <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">

      <div class="row g-3 mb-1" v-if="token_exists">

        <!-- Dashboard -->
        <div class="col-6" v-if="user_details.user_role == 'admin'">
          <a
            href="/dashboard"
            class="menu-card text-decoration-none text-dark d-flex justify-content-center flex-column align-items-center pointer"
          >
            <i class="bi bi-grid-3x3-gap-fill fs-1 mt-1"></i>
            <div class="fw-semibold text-xxs">Dashboard</div>
          </a>
        </div>

        <div class="col-6" v-if="token_exists && client_features.show_marketplace">
          <a
            href="/my_shop"
            class="menu-card text-decoration-none text-dark d-flex justify-content-center flex-column align-items-center pointer"
            role="button"
            aria-controls="menu_canvas"
          >
            <i class="fas fa-warehouse fa-fw text-black fs-3 mt-1 mb-2"></i>
            <div class="fw-semibold text-xxs">My Shop</div>
          </a>
        </div>
        <div class="col-6" v-if="token_exists && client_features.show_donations">
          <a
            href="/donation_campaigns"
            class="menu-card text-decoration-none text-dark d-flex justify-content-center flex-column align-items-center pointer"
            role="button"
            aria-controls="menu_canvas"
          >
            <i class="fas fa-hand-holding-heart fa-fw text-black fs-2"></i>
            <div class="fw-semibold text-xxs">Donations</div>
          </a>
        </div>

        <div class="col-6" v-if="client_features.show_marketplace && !isPortalPage && !is_business_page && !is_group_page">
          <a
            href="/my_orders"
            class="menu-card text-decoration-none text-dark d-flex justify-content-center flex-column align-items-center pointer"
            role="button"
            aria-controls="menu_canvas"
          >
            <i class="fas fa-bag-shopping fa-fw text-black fs-1 mt-1 mb-2"></i>
            <div class="fw-semibold text-xxs">My Orders</div>
          </a>
        </div>

        <!-- Community Assets -->
        <div class="col-6" v-if="!is_group_page && !isHomeFilterPage && !isPortalPage && client_features.show_assets">
          <a
            href="/community_asset"
            class="menu-card text-decoration-none text-dark d-flex justify-content-center flex-column align-items-center pointer"
          >
            <i class="fas fa-building text-black fs-1 mt-1 mb-2"></i>
            <div class="fw-semibold text-xxs">Community Assets</div>
          </a>
        </div>

        <!-- Library -->
        <div class="col-6" v-if="token_exists && client_features.show_library" >
        <a class="menu-card text-decoration-none text-dark d-flex justify-content-center flex-column align-items-center pointer" href="/library" role="button" aria-controls="menu_canvas">
          <i class="fas fa-cloud fa-fw text-black fs-1 mt-1"></i> <!-- cloud icon -->
          <span class="fw-semibold text-xxs">Library</span>
        </a>
        
      </div>
      <div class="col-6" v-if="token_exists && client_features.show_library" >
        <a class="menu-card text-decoration-none text-dark d-flex justify-content-center flex-column align-items-center pointer" href="/view_recent_uploads" role="button" aria-controls="menu_canvas">
          <i class="fas fa-file-alt fa-fw text-black fs-1 mt-1 mb-2"></i>
          <span class="fw-semibold text-xxs">Documents Resources</span>
        </a>
      </div>

        <!-- Upcoming Birthdays -->
        <div class="col-6" v-if="!is_group_page && !isHomeFilterPage && !isPortalPage && client_features.show_upcoming_birthdays">
          <a
            href="/view_all_birthdays"
            class="menu-card text-decoration-none text-dark d-flex justify-content-center flex-column align-items-center pointer"
          >
            <i class="bi bi-gift-fill fs-1 mt-1"></i>
            <div class="fw-semibold text-xxs">Upcoming Birthdays</div>
          </a>
        </div>

        <!-- Personal Profiles -->
        <div class="col-6" v-if="client_features.show_personal_profile">
          <a
            href="/view_personal_profiles"
            class="menu-card text-decoration-none text-dark d-flex justify-content-center flex-column align-items-center pointer"
          >
            <i class="fas fa-user-circle fa-fw text-black fs-1 mt-1 mb-2"></i>
            <div class="fw-semibold text-xxs">Personal Profiles</div>
          </a>
        </div>

        <!-- Business Profiles -->
        <div class="col-6" v-if="!tdm_domain && client_features.show_business_profile">
          <a
            href="/view_business_profiles"
            class="menu-card text-decoration-none text-dark d-flex justify-content-center flex-column align-items-center pointer"
          >
            <i class="fas fa-briefcase fa-fw text-black fs-1 mt-1 mb-2"></i>
            <div class="fw-semibold text-xxs">Business Profiles</div>
          </a>
        </div>
         <div class="col-6" v-if="client_features.show_marketplace">
          <a
            href="/ads_center"
            class="menu-card text-decoration-none text-dark d-flex justify-content-center flex-column align-items-center pointer"
          >
            <i class="fas fa-bullhorn fa-fw text-black fs-1 mt-1 mb-2"></i>
            <div class="fw-semibold text-xxs">Ads Centre</div>
          </a>
        </div>

      </div>

    </div>
  </div>

  <div class="modal fade" id="request_access" tabindex="-1" aria-labelledby="request_accessModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-5">
      <div class="modal-header">
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body d-flex justify-content-center">
        <p class="text-md fw-500">This is a private portal. Would you like to request access?</p>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-primary text-xs rounded-5 shadow" v-if="request_access">
          <div class="spinner-border text-light spinner-border-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </button>
        <button @click="requestAccess" v-else class="btn btn-primary text-xs rounded-5 shadow">Request Access</button>
         
      </div>
    </div>
  </div>
</div>


